import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, CardHeader, CardBody, Row, Col, Button, Label, FormGroup, Alert } from 'reactstrap'
import { getEmployee, resetEmployee, getEmployeeSells, resetEmployeeSells, getEmployeeSellsItems, resetEmployeeSellsItems } from '../../../../store/employee/actions'
import { formatHelper } from '../../../../common/helpers'
import { MainLoader, DataTable, Tab } from '../../../../components'
import MediaQuery from 'react-responsive'
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import * as columns from './_columns'
import { layout } from '../../../../common/constants'
import moment from 'moment';

class EmployeeDetail extends Component {
    constructor(props) {
        super(props);
        const startDate = moment().startOf('month')
        const endDate = moment().endOf('month')

        this.state = {
            page: 1,
            pageItems: 1,
            startDate: startDate,
            endDate: endDate,
            focusedInput: null,
        }
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleItemsPageChange = this.handleItemsPageChange.bind(this)
        this.renderSellTab = this.renderSellTab.bind(this)
        this.renderItemsTab = this.renderItemsTab.bind(this)
    }

    async componentDidMount() {
        const { page, startDate, endDate } = this.state
        this.props.getEmployee(this.props.match.params.id)
        this.props.getEmployeeSells({ page: page, startDate: startDate._d, endDate: endDate._d, id: this.props.match.params.id })
        this.props.getEmployeeSellsItems({ page: page, startDate: startDate._d, endDate: endDate._d, id: this.props.match.params.id })
    }
    async componentWillUnmount() {
        await this.props.resetEmployeeSells();
        await this.props.resetEmployeeSells();
        await this.props.resetEmployeeSellsItems();
    }

    performGetSells() {
        const { page, startDate, endDate } = this.state
        this.props.getEmployeeSells({ page: page, startDate: startDate._d, endDate: endDate._d, id: this.props.match.params.id })
    }


    performGetItems() {
        const { pageItems, startDate, endDate } = this.state
        this.props.getEmployeeSellsItems({ page: pageItems, startDate: startDate._d, endDate: endDate._d, id: this.props.match.params.id })
    }

    async handleDateChange(startDate, endDate) {
        await this.setState({ startDate, endDate })
        if (startDate != null && endDate != null) {
            this.performGetSells()
            this.performGetItems()
        }
    }

    async handlePageChange(page) {
        await this.setState({ page: page })
        this.performGetSells()
    }

    async handleItemsPageChange(page) {
        await this.setState({ pageItems: page })
        this.performGetItems()
    }

    renderField(label, value) {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label color='red'>{label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <p className="form-control-static">{value}</p>
                </Col>
            </FormGroup>
        )
    }

    renderImageField(label, value) {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label color='red'>{label}</Label>
                </Col>
                <Col xs="12" md="4">
                    {
                        value && <img src={value} style={{ maxHeight: 200 }} />
                    }
                </Col>
            </FormGroup>
        )
    }

    renderFields() {

        const employee = this.props.employee
        const document_type = employee.Document_type == null ? '' : employee.Document_type.name
        return (
            <div>
                {this.renderField('Codigo:', employee.code)}
                {this.renderField('Nombre:', employee.name)}
                {this.renderField('Apellidos:', employee.lastname)}
                {this.renderField('Tipo de Documento:', document_type)}
                {this.renderField('N° de Documento:', employee.dni)}
                {this.renderField('Cumpleaños:', formatHelper.toDateDDMMYYY(employee.birthday))}
                {this.renderField('Teléfono:', employee.cellphone)}
                {this.renderField('Email:', employee.email)}
                {this.renderField('Distrito:', employee.district)}
                {this.renderField('Dirección:', employee.address)}
                {this.renderField('Género:', formatHelper.toGender(employee.gender))}
                {this.renderField('Tienda:', employee.Store.name)}
                {this.renderImageField('Foto:', employee.photoUrl)}
                {this.renderField('Comentarios:', employee.comments)}
            </div>
        )
    }

    renderDataTable(columns, data, pageSize, total, loading) {
        return (
            <DataTable
                data={data}
                keyField='id'
                columns={columns}
                page={this.state.page}
                totalSize={total}
                loading={loading}
                sizePerPage={pageSize}
                onPageChange={this.handlePageChange}
            />
        )
    }

    renderItemsDataTable(columns, data, pageSize, total, loading) {
        return (
            <DataTable
                data={data}
                keyField='id'
                columns={columns}
                page={this.state.pageItems}
                totalSize={total}
                loading={loading}
                sizePerPage={pageSize}
                onPageChange={this.handleItemsPageChange}
            />
        )
    }

    renderSellTab(){
        const { sells, serviceError, serviceLoading, pageSize, total, totalSold } = this.props;

        return(
            (serviceError) ?
                <Alert color="danger">
                    {serviceError}
                </Alert>
                :
                (!serviceLoading) ?
                    <div>
                        <Row className="mb-2">  <Col><b>Total de Ventas (S/):</b> {formatHelper.toMoney(totalSold)}</Col> </Row>
                        <Row>


                            <Col>
                                <MediaQuery maxWidth={layout.XS_MAX_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                                    {this.renderDataTable(columns.employeeDetailXS(), sells, pageSize, total, serviceLoading)}
                                </MediaQuery>
                                <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                                    {this.renderDataTable(columns.employeeDetail(), sells, pageSize, total, serviceLoading)}
                                </MediaQuery>
                            </Col>
                        </Row>
                    </div> :
                    <MainLoader />
            
        )        
    }

    renderItemsTab(){
        const { items, sellItemsLoading, sellItemsError, sellItemspageSize, sellItemsTotal } = this.props
        return(
            (sellItemsError) ?
            <Alert color="danger">
                {sellItemsError}
            </Alert>
            :
            (!sellItemsLoading) ?
                <div>
                    <Row>
                        <Col>
                            <MediaQuery maxWidth={layout.XS_MAX_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                                {this.renderItemsDataTable(columns.employeeItemsDetailXS(), items, sellItemspageSize, sellItemsTotal, sellItemsLoading)}
                            </MediaQuery>
                            <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                                {this.renderItemsDataTable(columns.employeeItemsDetail(), items, sellItemspageSize, sellItemsTotal, sellItemsLoading)}
                            </MediaQuery>
                        </Col>
                    </Row>
                </div> :
                <MainLoader />
        )
    }

    render() {
        const { employee, loading, error } = this.props
        const { startDate, endDate } = this.state

        if (error) {
            return (
                <Alert color="danger">
                    {error}
                </Alert>
            )
        }
        if (loading) {
            return <MainLoader />
        }
        else if (!employee) return <div></div>
        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        Detalle del Empleado
                    </CardHeader>
                    <CardBody>
                        {this.renderFields()}
                        <Row className='mb-3'>
                            <Col md="12">
                                <DateRangePicker
                                    startDate={startDate}
                                    startDateId="startDate"
                                    endDate={endDate}
                                    endDateId="endDate"
                                    displayFormat={'DD/MM/YYYY'}
                                    onDatesChange={({ startDate, endDate }) => this.handleDateChange(startDate, endDate)}
                                    focusedInput={this.state.focusedInput}
                                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                                    startDatePlaceholderText='Fecha Inicio'
                                    endDatePlaceholderText='Fecha Fin'
                                    small
                                    isOutsideRange={() => false}
                                    hideKeyboardShortcutsPanel
                                    minimumNights={0}
                                />
                            </Col>
                        </Row>
                        <Tab
                            titles={['Ventas','Items']}
                            tabs={[this.renderSellTab, this.renderItemsTab]}
                        />
                        <Row>
                            <Col className='mt-3'>
                                <Button color='secondary' onClick={() => this.props.history.push('/administration/employees')} ><i className="fa fa-chevron-left mr-1" /> Volve</Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

function mapStateToProps(state) {

    const { employee, error, loading } = state.employee.activeEmployee
    const { sells, error: serviceError, loading: serviceLoading, pageSize, total, totalSold } = state.employee.employeeSellList
    const { items, error: sellItemsError, loading: sellItemsLoading, pageSize: sellItemspageSize, total: sellItemsTotal } = state.employee.employeeSellItemList

    return {
        employee,
        error,
        loading,
        sells,
        serviceError,
        serviceLoading,
        pageSize,
        total,
        totalSold,
        items,
        sellItemsError,
        sellItemsLoading,
        sellItemspageSize,
        sellItemsTotal,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getEmployee,
        resetEmployee,
        getEmployeeSells,
        resetEmployeeSells,
        getEmployeeSellsItems,
        resetEmployeeSellsItems,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDetail)



// WEBPACK FOOTER //
// ./src/scenes/Administration/Employee/EmployeeDetail/EmployeeDetail.js